export default {
    loginError: null,
    isLoggedIn: false,
};
